export enum MDSDotPulseLoaderKind {
  Light = "light",
  Dark = "dark",
  Brand = "brand",
}

export enum MDSDotPulseLoaderSize {
  Small = "small",
  Medium = "medium",
}

export interface MDSDotPulseLoaderProps {
  /** Style variant of the dot pulse loader */
  kind?: MDSDotPulseLoaderKind;
  /** Size of the dot pulse loader */
  size?: MDSDotPulseLoaderSize;
  /** Optional class name for additional styling */
  className?: string;
}
